module.exports = __webpack_public_path__ + "static/media/install06.41262743.png";